import { render, staticRenderFns } from "./AttributeUser.vue?vue&type=template&id=b27fc804"
import script from "./AttributeUser.vue?vue&type=script&lang=js"
export * from "./AttributeUser.vue?vue&type=script&lang=js"
import style0 from "./AttributeUser.vue?vue&type=style&index=0&id=b27fc804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports